import { onBeforeUnmount, onMounted, reactive } from 'vue';
import {
  initDevMode,
  onDevModeChange,
  toggleDevMode,
  type DevModeState,
} from './devmode';

/**
 * 开发模式的 Vue 适配层。
 * 核心逻辑在零框架的 `devmode.ts`；本文件只负责把它的「订阅推送」接到 Vue 的响应式上，
 * 并暴露给组件用的 init / toggle。
 *
 * 顶栏按钮的「是否本地环境 / 是否开启 / 是否按住 Alt」全部来自这里，单一数据源，
 * 不另发请求、不与 useVersionGuard 抢状态（见 AGENTS.md 开发模式一节）。
 *
 * 注意：state 用 `reactive` 而非 `ref` —— 这样模板里 `dm.state.local` 能直接按对象属性访问
 * （嵌套在普通对象里的 ref 不会被自动解包），类型也直接是 DevModeState。
 */
export function useDevMode() {
  const state = reactive<DevModeState>({ enabled: false, altHeld: false, local: false });
  let unsub: (() => void) | null = null;

  onMounted(() => {
    // 立即推一次当前值（local 可能为 false，按钮据此不渲染），随后订阅后续变化
    unsub = onDevModeChange((s) => {
      state.enabled = s.enabled;
      state.altHeld = s.altHeld;
      state.local = s.local;
    });
    void initDevMode();
  });

  onBeforeUnmount(() => {
    unsub?.();
    unsub = null;
  });

  function toggle(): boolean {
    return toggleDevMode();
  }

  return { state, toggle };
}
